<template>
  <div class="mb-3">
    <div class="po-search-card">
      <b-form-select
        class="select-style po-search-type"
        size="sm"
        :value="searchType"
        :options="searchTypeOptions"
        value-field="id"
        text-field="name"
        :disabled="disabled"
        @change="$emit('update:searchType', $event)"
      />
      <div class="po-search-input-wrap">
        <i class="mdi mdi-magnify po-search-icon"></i>
        <vue-autosuggest
          :value="searchText"
          :suggestions="suggestions"
          :limit="10"
          :input-props="inputProps"
          :disabled="disabled"
          :should-render-suggestions="(size, loading) => size >= 0 && !loading && searchText !== ''"
          @input="$emit('search-input', $event)"
          @selected="$emit('selected', $event.item)"
        >
          <template slot-scope="{ suggestion }">
            <div class="po-suggestion-item">
              <div class="d-flex align-items-start" style="gap: 8px">
                <ProductImage :src="suggestion.item.productImageUrl" />
                <div class="flex-grow-1">
                  <div class="text-muted" style="font-size: 11px">
                    {{ suggestion.item.barCode }} · ({{ suggestion.item.productCode }})
                  </div>
                  <div style="font-size: 13px">{{ suggestion.item.productName }}</div>
                  <div v-if="suggestion.item.imeiCode" class="po-imei-accent" style="font-size: 12px">
                    IMEI: {{ suggestion.item.imeiCode }}
                  </div>
                  <div v-if="showPrice && suggestion.item.originalPrice != null" style="font-size: 12px">
                    Giá vốn: {{ formatPrice(suggestion.item.originalPrice) }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </vue-autosuggest>
      </div>
    </div>
    <div v-if="showHint" class="po-search-hint">
      <i class="mdi mdi-information-outline"></i>
      Sản phẩm nhập phải khác sản phẩm xuất.
    </div>
  </div>
</template>

<script>
import ProductImage from '@/view/components/products/ProductImage.vue';
import { convertPrice } from '@/utils/common';

export default {
  name: 'ProductionOrderSearchBar',
  components: { ProductImage },
  props: {
    searchType: { type: Number, default: 2 },
    searchText: { type: String, default: '' },
    suggestions: { type: Array, default: () => [{ data: [] }] },
    disabled: { type: Boolean, default: true },
    showHint: { type: Boolean, default: false },
    showPrice: { type: Boolean, default: true },
  },
  data() {
    return {
      searchTypeOptions: [
        { id: 2, name: 'Tìm theo IMEI' },
        { id: 1, name: 'Tìm theo sản phẩm' },
      ],
      inputProps: {
        class: 'autosuggest__input',
        placeholder: 'Nhập IMEI hoặc tên SP để quét kho...',
      },
    };
  },
  methods: {
    formatPrice(value) {
      return convertPrice(value);
    },
  },
};
</script>
